export async function setPosts(context, params ) {
    try{
        context.commit('setPosts',params);
    }
    catch(e){
        console.log(e);
    }
}

export async function setPost(context, params ) {
    try{
        context.commit('setPost',params);
    }
    catch(e){
        console.log(e);
    }
}

export async function clearPost(context) {
    try{
        context.commit('clearPost');
    }
    catch(e){
        console.log(e);
    }
}

export async function setPostsByCategory(context, categoria_id) {
    try{
        context.commit('setPostsByCategory',categoria_id);
    }
    catch(e){
        console.log(e);
    }
}

export async function setPostsByTitle(context, titulo) {
    try{
        context.commit('setPostsByTitle',titulo);
    }
    catch(e){
        console.log(e);
    }
}

